// Library imports
import React from "react";
import styled from "styled-components";
import Checkbox from "../../../Common/Components/Checkbox";

// Local imports
import BlankProfilePhoto from "../../../../assets/img/blank_profile_photo.png";
import { removeOnClickBubble } from "utils";
import { setSelectedRecommendedContacts } from "../actions";
import { Popover } from "antd";

type Props = {
  contact_id: number;
  image?: string;
  personalityType?: String;
  userName?: String;
  disabled?: Boolean;
  // onClick?: any;
  handleAddPeople?: any;
  pColor?: string;
  email?: string;
  added?: boolean;
  selected?: boolean;
  showTip?: boolean;
  colored?: boolean;
  status?: string;
  designation?: string;
  organization?: string;
  isRecommended?: boolean;
  isSearched?: boolean;
  isDynamic?: boolean;
  isBounced?: boolean; // is unsubscribed or bounced
};
const PersonBadgeItem: React.FC<Props> = ({
  disabled,
  image,
  personalityType,
  userName,
  email,
  contact_id,
  handleAddPeople,
  pColor,
  added = false,
  selected = false,
  showTip,
  colored,
  designation,
  organization,
  status,
  isDynamic,
  isRecommended,
  isSearched,
  isBounced,
}) => {
  function handleOnClick(e: any) {
    e?.stopPropagation();
    e?.preventDefault();
    removeOnClickBubble(e);
    handleAddPeopleFunction();
  }

  function onClickCheckbox(e: any) {
    e.stopPropagation();
    handleAddPeopleFunction();
  }

  function handleAddPeopleFunction() {
    setSelectedRecommendedContacts(
      { id: contact_id, name: userName?.trim() === "" ? email : userName?.trim() },
      { isDynamic, isRecommended, isSearched }
    );
    if (handleAddPeople) {
      handleAddPeople(contact_id, userName, "contact", email);
    }
  }
  // console.log("PersonBadgeItem", selected);

  const contentInfo = () => {
    return (
      <WrapperContent>
        {organization ? (
          <div className="fix-row">
            <Heading>Organization</Heading>
            <Paragraph bold>{organization}</Paragraph>
          </div>
        ) : null}
        {email ? (
          <div className="fix-row">
            <Heading>Email</Heading>
            <Paragraph>{email}</Paragraph>
          </div>
        ) : null}
        {designation ? (
          <div className="fix-row">
            <Heading>Designation</Heading>
            <Paragraph bold>{designation}</Paragraph>
          </div>
        ) : null}
        {status === "Subscribed" || !status ? null : (
          <div className="fix-row">
            <Heading>Status</Heading>
            <Paragraph colored>{status}</Paragraph>
          </div>
        )}
      </WrapperContent>
    );
  };

  return (
    <Wrapper
      className={`${disabled || added ? "show-selected" : ""} ${isBounced ? 'greyed' : ''}`}
      onClick={!added && !isBounced ? (e) => handleOnClick(e) : undefined}
    >
      <div className="badge-wrapper">
        <div className="check-wrapper">
          <Checkbox checked={selected} disabled={isBounced} onChange={onClickCheckbox} />
        </div>
        <Popover
          placement="left"
          overlayInnerStyle={{
            color: "#0f0f0f",
            fontFamily: "Roboto",
            fontSize: 16,
            fontWeight: "400",
            lineHeight: 1.3,
            width: "320px",
            boxShadow: "0px 2px 60px 0px rgba(0,0,0,0.35)",
            borderRadius: 10,
          }}
          content={showTip ? contentInfo : null}
        >
          <span className="badge-img-wrapper" style={{ backgroundColor: pColor ? pColor : "#ffffff" }}>
            <img src={image ? image : BlankProfilePhoto} alt="" />
          </span>
          <span className="badge-name" style={{ backgroundColor: pColor ? pColor : "#ffffff" }}>
            {personalityType}
          </span>
        </Popover>
      </div>
      <h6 className="user-name" data-qa="qa-sidebar-username">
        {userName !== "" ? userName : email}
      </h6>
      <h6 className="email" data-qa="qa-sidebar-email">
        {email !== "" ? email : ""}
      </h6>
    </Wrapper>
  );
};

export default PersonBadgeItem;

const WrapperContent = styled.div`
  .fix-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 7px;
  }
`;

const Heading = styled.span`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  color: #000000;
`;

const Paragraph = styled.span<{ bold?: boolean; colored?: boolean }>`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  color: ${(props) => (props.colored ? "rgba(255, 149, 49, 1)" : "#5e7079")};
  font-weight: ${(props) => (props.bold ? "700" : "400")};
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
`;

const Wrapper = styled.label`
  width: 77px;
  height: 77px;
  margin: 0px 35px 70px 15px;
  cursor: pointer;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 58px;
    height: 58px;
    margin: 0px 25px 55px 10px;
  }
  &.greyed {
    filter: grayscale(100%);
  }
  &.show-selected {
    opacity: 0.5;
    pointer-events: none;
  }
  .badge-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    margin-top: 15px;
    .check-wrapper {
      position: absolute;
      top: -12px;
      right: -25px;
    }
    .badge-img-wrapper {
      height: 100%;
      width: 100%;
      background-color: #f0b520;
      border-radius: 50%;
      padding: 3px;
      display: block;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 2px;
      }
      img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        /* position: absolute;
        top: 2px;
        left: 2px; */
        /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 53px;
          height: 53px;
        } */
      }
    }
    .badge-name {
      background-color: #f0b520;
      font-family: "robotomedium";
      letter-spacing: 1px;
      font-weight: 400;
      font-size: 10px;
      color: #fff;
      padding: 2px 7px;
      position: absolute;
      bottom: -5px;
      left: 50%;
      border-radius: 9px;
      width: auto;
      transform: translateX(-50%);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 8px;
        border-radius: 6px;
      }
    }
  }
  .user-name {
    color: #424b50;
    font-family: "robotomedium";
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 77px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
      width: 58px;
    }
  }
  .email {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    letter-spacing: -0.144362px;
    color: #1ec252;
    opacity: 0.7;
    margin-top: 8px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 99px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
      width: 80px;
      margin-top: 2px;
    }
  }
`;
